import type { IViewModel } from './types';

export function bindIntegrations(vm: IViewModel) {
  vm._.comments.bind();
}
